module.exports = "/_next/static/images/3dcd14fd0ab34a32d6a9e1eff6c6b359-blue-frozen-icon.svg";